import { Button, styled } from '@mui/material';
import React from 'react';

interface AutocompleteFilterButtonProps {
  buttonRef?: React.Ref<HTMLButtonElement> | undefined;
  isDisabled: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  buttonLabel?: string;
}

const StyledAutocompleteFilterButton = styled(Button)(({ theme }) => ({
  height: '36px',
  boxShadow: 'none',
  textTransform: 'none',
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  '&:active': {
    backgroundColor: theme.hhglobal.neutral.gray900,
    color: theme.palette.common.white,
  },
  '&:disabled': {
    backgroundColor: theme.hhglobal.neutral.gray600,
    color: theme.palette.common.white,
  },
}));

function AutocompleteFilterButton(props: AutocompleteFilterButtonProps) {
  return (
    <StyledAutocompleteFilterButton
      ref={props.buttonRef ? props.buttonRef : undefined}
      variant='contained'
      data-testid='base-multi-autocomplete-filter'
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onClick={props.onClick}
      disabled={props.isDisabled}
    >
      {props.buttonLabel ?? 'Apply'}
    </StyledAutocompleteFilterButton>
  );
}

export default AutocompleteFilterButton;
